import { isMobile } from '@/device/deviceConfig'
import { openExternal } from '@/components/openExternal'
import { DOWNLOAD_APP_URL } from '@/header/downloadAppUrl'

export function openGetApp(deeplinkUrl: string): void {
    openExternal(isMobile() ? deeplinkUrl : DOWNLOAD_APP_URL)
}
